import { queryOptions } from '@tanstack/react-query';
import type {
  ListRecentLikersData,
  ListRecentLikersResponse,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

const getRecentLikersUrl: ListRecentLikersData['url'] =
  'users/@me/recent-likers' as const;

const getRecentLikersKey = () => ['likes', 'recent-likers'] as const;

export function getRecentLikersOptions<T = ListRecentLikersResponse>() {
  return queryOptions<ListRecentLikersResponse, unknown, T>({
    queryKey: getRecentLikersKey(),
    queryFn: () =>
      PrivateApi.get(getRecentLikersUrl).json<ListRecentLikersResponse>(),
  });
}
